import { render, staticRenderFns } from "./howtouse.vue?vue&type=template&id=5831307f&scoped=true"
import script from "./howtouse.vue?vue&type=script&lang=js"
export * from "./howtouse.vue?vue&type=script&lang=js"
import style0 from "./howtouse.vue?vue&type=style&index=0&id=5831307f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5831307f",
  null
  
)

export default component.exports